export enum RecaptchaClientType {
  INVISIBLE = "invisible",
  NORMAL = "normal",
}
